import constants from '../helpers/constants.js';
import _ from 'lodash';
import { hubConnection, signalR } from 'signalr-no-jquery';
import { MDTApp } from '../actions/bootAction.js';
import { NotificationListStore } from '../actions/NotificationListStore.js';


let GLOBAL_RETRY_TIMER = 1;
export function initNotification(store) {
    return (dispatch, getState) => {
        dispatch(NotificationListStore.init());

        let wsConnected = getState().notification.wsConnected || false;
        let wsReconnecting = getState().notification.wsReconnecting || false;
        if (wsConnected || wsReconnecting) {
            console.log("Web Socket is connected or re-connecnting");
            return;
        }

        const connection = hubConnection(getWebSocketUrl(), getConnectionOption());

        // set up Web socket proxy list
        webSocketProxy(connection, dispatch);

        handleWebSocketEvent(connection, dispatch);

        // connect
        connection.start({ jsonp: true, transport: "webSockets", })
            .done(function() {
                console.log('Now connected, connection ID=' + connection.id);
                dispatch(updateWebSocketStatus(true));

            })
            .fail(function() {
                console.log('Could not connect');
                dispatch(updateWebSocketStatus(false));
            });

    }
}

export function showHideWsNotification(data) {
    return { type: constants.WEB_SOCKET_LATEST_NOTIFICATION_SHOW, data };
}

function getWebSocketUrl() {
    return window.location.protocol + '//' + window.location.host;
}

function webSocketProxy(connection, dispatch) {
    const notificationHub = createProxyNotificationHub(connection, dispatch);
    const cyclecountHub = createProxyCyclecountHub(connection, dispatch);
    const chat = createProxyChat(connection, dispatch);
}

function handleWebSocketEvent(conn, dispatch) {

    conn.starting((conn) => {
            console.log("Web Method starting");
            dispatch(updateWebSocketStatus(false));
        }).stateChanged((change) => webSocketStateChanged(change, dispatch))
        .received((data) => {
            console.log("data recived");
        })
        .reconnecting((conn) => {
            console.log("web socket reconnecting - ");
            dispatch(updateWebSocketReconnecting(true));
            dispatch(updateWebSocketStatus(false));
        }).reconnected(() => {
            console.log("web socket reconnected - ");
            dispatch(updateWebSocketReconnecting(false));
            dispatch(updateWebSocketStatus(true));
        }).error((conn, errorData, sendData) => {
            console.log("web socket error - " + errorData);
        });
}


function webSocketStateChanged(change, dispatch) {
    if (change.newState === signalR.connectionState.reconnecting) {
        console.log('Re-connecting');
    } else if (change.newState === signalR.connectionState.disconnected) {
        let retryInSeconds = GLOBAL_RETRY_TIMER * 2;
        if (retryInSeconds > 30) {
            retryInSeconds = 30
        }
        GLOBAL_RETRY_TIMER = retryInSeconds
        setTimeout(() => {
            dispatch(updateWebSocketStatus(false));
            dispatch(updateWebSocketReconnecting(false));
            dispatch(initNotification());
        }, retryInSeconds * 1000);
        console.log('The server is disconnected');
    } else if (change.newState === signalR.connectionState.connecting) {
        console.log('The server is connecting');
    } else if (change.newState === signalR.connectionState.connected) {
        console.log('The server is online');
    }
}


function handleWebSocketRecivedData(data, dispatch) {
    console.log("recived from websocket - ");
    console.log(data);
    dispatch(updateUserNotification(data));
    dispatch(showHideWsNotification(true));
    dispatch(NotificationListStore.getNotificationCount());

}

function createProxyCyclecountHub(conn, dispatch) {
    let cyclecountHub = createHubProxy(conn, 'cyclecountHub');
    cyclecountHub.on('newcyclecount', function(data) {
        console.log(data);
    });

    return cyclecountHub;
}

function createProxyChat(conn, dispatch) {
    let chat = createHubProxy(conn, 'chat');
    chat.on('newchat', function(data) {
        console.log(data);
    });
    return chat;
}

function createProxyNotificationHub(conn, dispatch) {

    let notificationHub = createHubProxy(conn, 'notificationHub');

    // set up event listeners i.e. for incoming "notificaton" event
    notificationHub.on('newnotificationv2', (data) => handleWebSocketRecivedData(data, dispatch))
                   .on('newnotification', (data) => {});

    return notificationHub;

}

function createHubProxy(conn, proxyName) {
    return conn.createHubProxy(proxyName);
}

function getConnectionOption() {
    return {
        logger: MDTApp.getSetting('realtimeDebug', false),
        qs: {
            access_token: localStorage.getItem('apiToken')
        },
        useDefaultPath: true
    }
}

function updateUserNotification(data) {
    return { type: constants.WEB_SOCKET_LATEST_NOTIFICATION, data };
}

function updateWebSocketReconnecting(data) {
    return { type: constants.WEB_SOCKET_RECONNECTING, data };
}

function updateWebSocketStatus(data) {
    return { type: constants.WEB_SOCKET_CONNECTED, data };
}